import Link from 'next/link'
import { Button } from '@ui/base/button'

import { container, noteText, sectionTitle } from './typography'

/** Кнопка последнего экрана: куда ведёт и что на ней написано. */
export type LandingCallAction = { href: string; label: string }

/** Последний экран лендинга: тёмная плашка с главным действием. */
export const LandingFinalCall = ({
  action,
  note,
  secondary,
  text,
  title,
}: {
  /** Главное действие страницы — крупная кнопка. */
  action: LandingCallAction
  /** Строка под кнопками: короткие условия вроде «бесплатно · без договора». */
  note: string
  /** Запасной путь для тех, кто не готов к главному действию. */
  secondary: LandingCallAction
  text: string
  title: string
}) => (
  <section
    aria-labelledby="landing-final-title"
    className="bg-surface-inverse text-surface-inverse-foreground relative"
  >
    {/* Синее свечение в правом верхнем углу — то же пятно, что и за заголовком первого экрана:
        страница начинается и заканчивается одним приёмом. */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage:
          'radial-gradient(46% 78% at 78% 8%, color-mix(in srgb, var(--primary) 34%, transparent) 0%, transparent 70%)',
      }}
    />

    <div
      className={`${container} relative grid items-end gap-8 py-16 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)] lg:gap-x-[clamp(32px,6vw,80px)] lg:py-20`}
    >
      <div>
        <h2 id="landing-final-title" className={sectionTitle}>
          {title}
        </h2>
        <p className="text-surface-inverse-muted-foreground mt-5 max-w-[54ch] text-[17px] leading-[1.65]">{text}</p>
      </div>

      <div className="flex flex-col items-start gap-3">
        <Button size="lg" render={<Link href={action.href} />}>
          {action.label}
        </Button>
        <Button size="lg" variant="outline-inverse" render={<Link href={secondary.href} />}>
          {secondary.label}
        </Button>
        <span className={`${noteText} text-surface-inverse-muted-foreground`}>{note}</span>
      </div>
    </div>
  </section>
)
